/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_Creatorcode_Yesusecode3Inputs */

const id_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya, gunakan kode`)
};

const ms_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya, guna kod`)
};

const da_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, brug kode`)
};

const de_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, Code verwenden`)
};

const en_us2_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, use code`)
};

const es_es2_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, usar código`)
};

const es_mx2_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, usar código`)
};

const fil_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oo, gamitin ang code`)
};

const fr_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, utiliser le code`)
};

const it_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, usa il codice`)
};

const hu_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Igen, használd a kódot`)
};

const nl_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, gebruik code`)
};

const no_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, bruk kode`)
};

const pl_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tak, użyj kodu`)
};

const pt_br2_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, use o código`)
};

const pt_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, usar código`)
};

const ro_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da, folosește codul`)
};

const fi_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kyllä, käytä koodia`)
};

const sv_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, använd koden`)
};

const vi_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có, sử dụng mã`)
};

const tr_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evet, kodu kullan`)
};

const cs_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano, použít kód`)
};

const bg_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да, използвай кода`)
};

const ru_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да, использовать код`)
};

const uk_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Так, використати код`)
};

const ar_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نعم، استخدم الرمز`)
};

const hi_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ, कोड का उपयोग करें`)
};

const th_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช่ ใช้โค้ด`)
};

const ja_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、コードを使用する`)
};

const zh_cn2_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的，使用代码`)
};

const zh_hant1_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的，使用代碼`)
};

const ko_store_creatorcode_yesusecode3 = /** @type {(inputs: Store_Creatorcode_Yesusecode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네, 코드 사용`)
};

/**
* | output |
* | --- |
* | "Yes, use code" |
*
* @param {Store_Creatorcode_Yesusecode3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const store_creatorcode_yesusecode3 = /** @type {((inputs?: Store_Creatorcode_Yesusecode3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Creatorcode_Yesusecode3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_store_creatorcode_yesusecode3(inputs)
	if (locale === "ms") return ms_store_creatorcode_yesusecode3(inputs)
	if (locale === "da") return da_store_creatorcode_yesusecode3(inputs)
	if (locale === "de") return de_store_creatorcode_yesusecode3(inputs)
	if (locale === "en-US") return en_us2_store_creatorcode_yesusecode3(inputs)
	if (locale === "es-ES") return es_es2_store_creatorcode_yesusecode3(inputs)
	if (locale === "es-MX") return es_mx2_store_creatorcode_yesusecode3(inputs)
	if (locale === "fil") return fil_store_creatorcode_yesusecode3(inputs)
	if (locale === "fr") return fr_store_creatorcode_yesusecode3(inputs)
	if (locale === "it") return it_store_creatorcode_yesusecode3(inputs)
	if (locale === "hu") return hu_store_creatorcode_yesusecode3(inputs)
	if (locale === "nl") return nl_store_creatorcode_yesusecode3(inputs)
	if (locale === "no") return no_store_creatorcode_yesusecode3(inputs)
	if (locale === "pl") return pl_store_creatorcode_yesusecode3(inputs)
	if (locale === "pt-BR") return pt_br2_store_creatorcode_yesusecode3(inputs)
	if (locale === "pt") return pt_store_creatorcode_yesusecode3(inputs)
	if (locale === "ro") return ro_store_creatorcode_yesusecode3(inputs)
	if (locale === "fi") return fi_store_creatorcode_yesusecode3(inputs)
	if (locale === "sv") return sv_store_creatorcode_yesusecode3(inputs)
	if (locale === "vi") return vi_store_creatorcode_yesusecode3(inputs)
	if (locale === "tr") return tr_store_creatorcode_yesusecode3(inputs)
	if (locale === "cs") return cs_store_creatorcode_yesusecode3(inputs)
	if (locale === "bg") return bg_store_creatorcode_yesusecode3(inputs)
	if (locale === "ru") return ru_store_creatorcode_yesusecode3(inputs)
	if (locale === "uk") return uk_store_creatorcode_yesusecode3(inputs)
	if (locale === "ar") return ar_store_creatorcode_yesusecode3(inputs)
	if (locale === "hi") return hi_store_creatorcode_yesusecode3(inputs)
	if (locale === "th") return th_store_creatorcode_yesusecode3(inputs)
	if (locale === "ja") return ja_store_creatorcode_yesusecode3(inputs)
	if (locale === "zh-CN") return zh_cn2_store_creatorcode_yesusecode3(inputs)
	if (locale === "zh-Hant") return zh_hant1_store_creatorcode_yesusecode3(inputs)
	return ko_store_creatorcode_yesusecode3(inputs)
});
export { store_creatorcode_yesusecode3 as "store.creatorCode.yesUseCode" }